// extracted by mini-css-extract-plugin
var _1 = "gpwVKM";
var _2 = "PwOkOW";
var _3 = "_3AmBtO";
var _4 = "g9qZ9f";
var _5 = "pyalZa";
var _6 = "D_pf2z";
var _7 = "RN548z";
var _8 = "D13MEN";
var _9 = "_UYrNd";
var _a = "t2SdWn";
var _b = "kb1cTs";
var _c = "Qhf3cr";
var _d = "q9mI8g";
var _e = "PZWbip";
var _f = "_BJbpG";
var _10 = "B3XHGp";
var _11 = "M3x6cE";
var _12 = "FKWI9Z";
var _13 = "n25Nos";
var _14 = "YY5v1n";
var _15 = "_bVxNV";
var _16 = "SCAyd8";
var _17 = "E3EdJj";
var _18 = "tnh8wN";
var _19 = "W3ldyO";
export { _1 as "alignItems", _2 as "button", _3 as "buttonsContainer", _4 as "disabledTab", _5 as "greeting", _6 as "helpText", _7 as "helpTextAttendanceDisabled", _8 as "hour", _9 as "summaryCard", _a as "summaryCardTitle", _b as "summaryGrid", _c as "summaryRow", _d as "tab", _e as "tabActive", _f as "tabDisabled", _10 as "tabsContainer", _11 as "tabsScroller", _12 as "tabsWrapper", _13 as "turnCompletedBanner", _14 as "turnFullName", _15 as "turnStatusMessage", _16 as "turnStatusMessageSuccess", _17 as "turnSummary", _18 as "turnsTabMenu", _19 as "withoutFood" }
